module.exports = __webpack_public_path__ + "static/rg-02-3c2b1f9b3a5e03a684267cf1492f6ffc.jpg";